<div class="subHeaderWrapper" id="sub-header-container" [ngClass]="{'!tw-bg-[#f5f5f5]':isIframe }">
  <div class="tw-flex tw-gap-2 tw-items-center">
    <button type="button" class="tw-flex tw-w-4 tw-h-4 tablet:tw-w-5 tablet:tw-h-5 laptop:tw-w-6 laptop:tw-h-6 tw-cursor-pointer" (click)="onBackClick()">
      <i-icon [name]="'arrow-back'" [height]="'tw-h-full'" [width]="'tw-w-full'"></i-icon>
    </button>
    <span class="tw-font-bold tw-text-sm tablet:tw-text-base laptop:tw-text-lg laptop:tw-leading-6">{{ backText }}</span>
    <ng-content select="[badge]"></ng-content>
  </div>

  <div class="tw-flex tw-justify-center">
    <div class="tw-block">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="tw-block">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>
